import type { PluginInstallFunction } from './types'

// Vue 3 Compatable Version
export const install: PluginInstallFunction = app => {
  const pinia = createPinia()
  app.use(pinia)
}
